<template>
  <div
    id="context-menu-location"
    class="context-menu">
    <span>
      <div
        @click="pinConversation"
        class="context-menu-item">
        <IconV2 name="v2-star1" />
        <span class="font-13 text-grey600">{{ conversation.isPin ? "Bỏ ghim" : "Ghim hội thoại" }}</span>
      </div>
      <div
        v-if="!conversation.group && !conversation.page"
        @click="addGroup"
        class="context-menu-item">
        <IconV2 name="v2-group-add" />
        <span class="font-13 text-grey600">Tạo nhóm</span>
      </div>
      <div
        v-if="conversation.group"
        @click="addMember"
        class="context-menu-item">
        <IconV2 name="v2-group-add" />
        <span class="font-13 text-grey600">Thêm thành viên</span>
      </div>
      <div
        @click="conversation.unreadCount ? unread(conversation.id) : setRead(conversation.id)"
        class="context-menu-item">
        <IconV2 name="v2-unread1" />
        <span class="font-13 text-grey600">{{ conversation.unreadCount ? "Đánh dấu đã đọc" : "Đánh dấu chưa đọc" }}</span>
      </div>
      <div
        @click="hideConversation"
        class="context-menu-item">
        <IconV2 name="v2-hide" />
        <span class="font-13 text-grey600">Ẩn trò chuyện</span>
      </div>
      <el-divider class="m-0 p-0" />
      <div
        @click="muteConversation"
        class="context-menu-item">
        <IconV2 name="v2-notification_important" />
        <span class="font-13 text-grey600">{{ conversation.pushNotify ? "Tắt thông báo" : "Bật thông báo" }}</span>
      </div>
      <span
        class="pa-0"
        @mouseleave="hideSubMenu">
        <div
          class="context-menu-item"
          @click="manageTagConversation">
          <IconV2 name="v2-setting1" />
          <span class="font-13 text-grey600">Quản lý thẻ</span>
          <!-- <IconV2
            class="px-0 ms-4"
            name="v2-arrow2_right" /> -->
        </div>
        <div
          id="context-sub-menu-location"
          @mouseover="showSubMenu"
          v-show="isSubMenuVisible"
          class="sub-menu"
          :class="{
            'sub-menu-left': positionSubMenu === 'left',
            'sub-menu-right': positionSubMenu === 'right',
          }">
          <div
            @click="handleMenuClick('createFolder')"
            class="context-menu-item">
            <IconV2
              name="v2-tag"
              color="red" />
            <span class="font-13 text-grey600">Khách quen</span>
          </div>
          <div
            @click="handleMenuClick('createFolder')"
            class="context-menu-item">
            <IconV2
              name="v2-tag"
              color="green" />
            <span class="font-13 text-grey600">Khách lạ</span>
          </div>
        </div>
      </span>
      <el-divider class="m-0 p-0" />
      <div
        v-if="conversation.group"
        @click="leaveGroup"
        class="context-menu-item">
        <IconV2 name="v2-exit" />
        <span class="font-13 text-grey600">Rời khỏi nhóm</span>
      </div>
      <div
        v-if="!conversation.group && !conversation.page"
        @click="actionBlockUser(!profile.isBlocked ? 'block' : 'unblock')"
        class="context-menu-item">
        <IconV2 name="v2-block" />
        <span class="font-13 text-grey600">{{ !profile.isBlocked ? "Chặn người dùng" : "Bỏ chặn" }}</span>
      </div>
    </span>

    <!-- <el-dialog
      title="Tạo nhóm"
      top="2vh"
      :visible.sync="dialogCreateGroup"
      :close-on-click-modal="false"
      width="800px"
      destroy-on-close
      append-to-body
      @opened="setId">
      <create-group
        ref="createGrMsg"
        :account-id="conversation.accountId"
        :userId="getUserId"
        @close="dialogCreateGroup = false" />
    </el-dialog> -->

    <DialogCreateGroup
      v-if="dialogCreateGroup"
      :dialogCreateGroup="dialogCreateGroup"
      :account-id="conversation.accountId"
      :userId="getUserId"
      @close="dialogCreateGroup = false" />

    <!-- <el-dialog
      v-if="dialogGroup"
      width="800px"
      top="40px"
      :visible.sync="dialogGroup"
      title="Thêm thành viên"
      append-to-body
      destroy-on-close>
      <AddMember
        :conversation="conversation"
        :members="members"
        @close="dialogGroup = false" />
    </el-dialog> -->

    <DialogAddMember
      v-if="dialogGroup"
      :dialogAddMember="dialogGroup"
      :conversation="conversation"
      :members="members"
      @close="dialogGroup = false"
      @addMembers="$emit('getGroupInfo', conversation)" />

    <el-dialog
      v-if="showTagManage"
      class="dialogTagManage"
      top="40px"
      :visible.sync="showTagManage"
      title="Lịch sử gắn tag"
      append-to-body
      width="760px"
      destroy-on-close>
      <div
        slot="title"
        class="d-flex align-items-center justify-content-between pb-2 px-3 py-2 border-bottom"
        style="margin-top: -10px">
        <div class="d-flex align-items-center mt-2">
          <span class="font-16 fw-700">Quản lý thẻ</span>
        </div>
      </div>
      <TagHistoryPopupV2 :conversation-id="conversation.id" />
    </el-dialog>
  </div>
</template>

<script>
// import CreateGroup from "../contact/CreateGroup";
// import AddMember from "@/components/AddMember";
import TagHistoryPopupV2 from "../tag/TagHistoryPopupV2.vue";
import DialogCreateGroup from "../message/DialogCreateGroup.vue";
import DialogAddMember from "../message/DialogAddMember.vue";

export default {
  props: ["conversation", "profile", "members"],
  components: {
    // CreateGroup,
    // AddMember,
    TagHistoryPopupV2,
    DialogCreateGroup,
    DialogAddMember,
  },
  data() {
    return {
      positionSubMenu: "left",
      isSubMenuVisible: false,
      dialogGroup: false,
      dialogCreateGroup: false,
      showTagManage: false,
    };
  },
  computed: {
    getUserId() {
      if (!this.profile) {
        return null;
      } else {
        return this.profile.userId;
      }
    },
  },
  methods: {
    setPosition(event) {
      const menu = document.getElementById("context-menu-location");
      if (window.innerHeight - event.clientY > 315) {
        menu.style.top = `${event.clientY}px`;
      }
    },
    handleMenuClick(e) {
      console.log(e);
    },
    hideSubMenu() {
      this.isSubMenuVisible = false;
    },
    showSubMenu() {
      this.isSubMenuVisible = true;
    },
    pinConversation() {
      let request = [];
      if (this.conversation.isPin) {
        let filterIdx = this.app.pinConversations.findIndex((m) => m.id == this.conversation.id);
        if (filterIdx > -1) {
          this.app.pinConversations.splice(filterIdx, 1);
        }
      } else {
        request.push({
          accountId: this.conversation.accountId,
          conversationId: this.conversation.id,
        });
      }
      this.app.pinConversations.forEach((p) => {
        request.push({
          accountId: p.accountId,
          conversationId: p.id,
        });
      });
      this.$http.post("/api/conversation/pin/save", { items: request }).then(() => this.fetchPinConversation());
    },
    addGroup() {
      // this.dialogCreateGroup = true;
      this.$emit("addGroup", this.conversation);
    },
    setId() {
      this.$refs.createGrMsg.setAccountId(this.conversation.accountId);
    },
    addMember() {
      this.$emit("addMembers", this.conversation, this.members.length);
    },
    hideConversation() {
      this.$confirm("Bạn có chắc chắn muốn ẩn liên hệ này trong phần Danh sách tin nhắn không?", "Xác nhận ẩn liên hệ", {
        confirmButtonText: "Xác nhận",
        cancelButtonText: "Hủy",
        type: "warning",
      }).then(async () => {
        await this.$http.get("/api/conversation/hidden", {
          params: {
            accountId: this.conversation.accountId,
            conversationId: this.conversation.id,
            hidden: true,
          },
        });
        this.$bus.$emit("hideConversation", this.conversation);
      });
    },
    async muteConversation() {
      await this.$http.get("/api/conversation/pushNotify", {
        params: {
          accountId: this.conversation.accountId,
          conversationId: this.conversation.id,
          pushNotify: !this.conversation.pushNotify,
        },
      });
      this.conversation.pushNotify = !this.conversation.pushNotify;
    },
    manageTagConversation() {
      this.showTagManage = true;
    },
    actionBlockUser(action) {
      let request = {
        accountId: this.conversation.accountId,
        friendId: this.conversation.toId,
        action: action,
        conversationId: this.conversation.id,
      };
      this.$http.post("/api/message/block", request).then((resp) => {
        if (resp?.data?.error_message !== "Successful.") return this.alert("error", "Có lỗi xảy ra vui lòng thử lại");
        if (action === "block") {
          this.profile.isBlocked = 1;
          this.alert("success", "Chặn thành công, người dùng này sẽ không thể gửi tin nhắn tới bạn");
        } else {
          this.profile.isBlocked = 0;
          this.alert("success", "Bỏ chặn thành công");
        }
        // this.$bus.$emit("handleBlock", { action: action, toId: this.conversation.toId });
      });
    },
    leaveGroup() {
      this.$http
        .get("/api/conversation/leaveGroup", {
          params: {
            groupId: this.conversation.toId,
            accountId: this.conversation.accountId,
          },
        })
        .then((resp) => {
          if (resp.data?.error_message === "Successful.") {
            // this.alert("success", "Rời nhóm thành công");
            this.$emit("getGroupInfo", this.conversation);
          } else this.alert("error", "Có lỗi xảy ra, vui lòng thử lại");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.sub-menu {
  position: absolute;
  bottom: 0;
  /* left: 101%; */
  /* right: 101%; */
  background-color: #fff;
  border: thin solid #f5f6f9;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  cursor: pointer;
  min-width: 150px;
  padding: 0 !important;
}

.sub-menu-left {
  position: absolute;
  left: 101% !important;
}

.sub-menu-right {
  position: absolute;
  right: 101% !important;
}

.sub-menu div {
  padding: 0.55rem 0.5rem;
}

.context-menu {
  position: fixed;
  background-color: #fff;
  border: thin solid #f5f6f9;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  cursor: pointer;
}

.context-menu div {
  padding: 0.25rem 0.5rem 0.25rem 0.25rem;
}

.context-menu-item {
  display: flex;
  align-items: center;
}

.context-menu-item:hover {
  color: var(--el-color-primary);
  background-color: #e8f0fb;
}
</style>